import { Body14Regular } from "@/components/typography/Body14Regular";
import { Radio, Table } from "flowbite-react";
import { ErpDataDto } from "../../../types/dto/erp-data-dto";
import { CustomCell } from "../CustomCell";

interface Props {
  data: ErpDataDto;
  selectedErpCode: string;
  handleSelectErpCode: (erpCode: string) => void;
}

export const ItemCodeTableRow: React.FC<Props> = ({
  data,
  selectedErpCode,
  handleSelectErpCode,
}) => {
  return (
    <Table.Row className="bg-white text-semantic-text-body">
      <Table.Cell>
        <CustomCell>
          <Radio
            className="mr-[8px] text-semantic-text-heading"
            checked={selectedErpCode === data.erpCode}
            onClick={() => handleSelectErpCode(data.erpCode)}
          />
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.modelName}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.erpCode}</Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
